import React from 'react'
import { Form, FormControl, FormField, FormItem, FormLabel } from '@/Components/ui/form'
import { Input } from '@/Components/ui/input'
import SearchableDropdown from '@/Components/Common/SearchableDropdown'
import { Popover, PopoverContent, PopoverTrigger } from '@/Components/ui/popover'
import { format } from 'date-fns'
import { CalendarIcon } from 'lucide-react'
import { cn } from '@/lib/utils'
import { Calendar } from '@/Components/ui/calendar'
import { ScrollArea, ScrollBar } from '@/Components/ui/scroll-area'
import { Button } from '@/Components/ui/button'
import Constant from '@/utils/Constant'
import DateTimePicker from '@/Components/Common/DateTimePicker'
import { Textarea } from '@/Components/ui/textarea'
const Overview = ({ form, chartLockIssue, holdReason, technicalIssue, event, updateEvent }) => {
    return (
        <>
            <div className="grid grid-cols-3 gap-y-3 gap-x-6 mt-5">
                <FormField
                    control={form.control}
                    name="chart_status"
                    render={({ field }) => (
                        <FormItem className="space-y-1">
                            <FormLabel>Chart Status</FormLabel>
                            <FormControl>
                                <Input
                                    type="text"
                                    className=" focus-visible:ring-transparent space-0 mt-0 text-security"
                                    placeholder="Chart Status"
                                    value={event?.work_allocation?.chart_status}
                                    disabled
                                />
                            </FormControl>
                        </FormItem>
                    )}
                />
                <FormField
                    control={form.control}
                    name="payor_type"
                    render={({ field }) => (
                        <FormItem className="space-y-1">
                            <FormLabel>Payor Type(As Per HCHB)</FormLabel>
                            <FormControl>
                                <Input
                                    type="text"
                                    className=" focus-visible:ring-transparent space-0 mt-0 text-security"
                                    placeholder="Payor Type"
                                    value={event?.work_allocation?.payor_type_hchb}
                                    disabled
                                />
                            </FormControl>
                        </FormItem>
                    )}
                />
                <FormField
                    control={form.control}
                    name="mitem_payor_type"
                    render={({ field }) => (
                        <FormItem className="space-y-1">
                            <FormLabel>Mitem Payor Type</FormLabel>
                            <FormControl>
                                <Input
                                    type="text"
                                    className=" focus-visible:ring-transparent space-0 mt-0 text-security"
                                    placeholder="Mitem Payor Type"
                                    value={event?.work_allocation?.mitem_payortype}
                                    disabled
                                />
                            </FormControl>
                        </FormItem>
                    )}
                />
                <FormField
                    control={form.control}
                    name="priority"
                    render={({ field }) => (
                        <FormItem className="space-y-1">
                            <FormLabel>Priority</FormLabel>
                            <FormControl>
                                <SearchableDropdown
                                    options={[
                                        { priority: 'High', name: 'High' },
                                        { priority: '', name: '' },
                                    ]}
                                    selectedVal={event?.work_allocation?.priority}
                                    handleChange={(val) => {
                                        updateEvent({
                                            work_allocation: {
                                                ...event.work_allocation,
                                                priority: val,
                                            },
                                            update_obj: {
                                                name: event?.work_allocation?.name,
                                                data: {
                                                    priority: val,
                                                },
                                            },
                                        })
                                    }}
                                    placeholder="Select Priority"
                                    label="priority"
                                />
                            </FormControl>
                        </FormItem>
                    )}
                />

                <FormField
                    control={form.control}
                    name="time"
                    render={({ field }) => (
                        <FormItem className="flex flex-col mt-1">
                            <FormLabel required={true}>Arrived Date</FormLabel>
                            <Input form={form} name="time" field={field} value={event?.work_allocation?.arrived_date} disabled />
                        </FormItem>
                    )}
                />

                <FormField
                    control={form.control}
                    name="chart_lock_issue"
                    render={({ field }) => (
                        <FormItem className="space-y-1">
                            <FormLabel>Chart Lock Issue</FormLabel>
                            <FormControl>
                                <SearchableDropdown
                                    options={chartLockIssue}
                                    selectedVal={event?.work_allocation?.chart_lock_issue}
                                    handleChange={(val) =>
                                        updateEvent({
                                            work_allocation: {
                                                ...event.work_allocation,
                                                chart_lock_issue: val,
                                            },
                                            update_obj: {
                                                name: event?.work_allocation?.name,
                                                data: {
                                                    chart_lock_issue: val,
                                                },
                                            },
                                        })
                                    }
                                    placeholder="Chart Lock Issue"
                                    label="chart_lock_issue"
                                />
                            </FormControl>
                        </FormItem>
                    )}
                />

                <FormField
                    control={form.control}
                    name="status"
                    render={({ field }) => (
                        <FormItem className="space-y-1">
                            <FormLabel>Status</FormLabel>
                            <FormControl>
                                <SearchableDropdown
                                    options={[{ status: 'Active' }, { status: 'Inactive' }]}
                                    selectedVal={event?.work_allocation?.status}
                                    handleChange={(val) =>
                                        updateEvent({
                                            work_allocation: {
                                                ...event.work_allocation,
                                                status: val,
                                            },
                                            update_obj: {
                                                name: event?.work_allocation?.name,
                                                data: {
                                                    status: val,
                                                },
                                            },
                                        })
                                    }
                                    placeholder="Status"
                                    label="status"
                                />
                            </FormControl>
                        </FormItem>
                    )}
                />

                <FormField
                    control={form.control}
                    name="age_of_chart"
                    render={({ field }) => (
                        <FormItem className="space-y-1">
                            <FormLabel>Age of Chart</FormLabel>
                            <FormControl>
                                <Input
                                    type="text"
                                    className=" focus-visible:ring-transparent space-0 mt-0 text-security"
                                    placeholder="Age of Chart"
                                    value={event?.work_allocation?.age_of_chart}
                                />
                            </FormControl>
                        </FormItem>
                    )}
                />

                <FormField
                    control={form.control}
                    name="hold_reason"
                    render={({ field }) => (
                        <FormItem className="space-y-1">
                            <FormLabel>Hold Reason</FormLabel>
                            <FormControl>
                                <SearchableDropdown
                                    options={holdReason}
                                    selectedVal={event?.work_allocation?.hold_reason}
                                    handleChange={(val) =>
                                        updateEvent({
                                            work_allocation: {
                                                ...event.work_allocation,
                                                hold_reason: val,
                                            },
                                            update_obj: {
                                                name: event?.work_allocation?.name,
                                                data: {
                                                    hold_reason: val,
                                                },
                                            },
                                        })
                                    }
                                    placeholder="Select Hold Reason"
                                    label="holdstatus"
                                />
                            </FormControl>
                        </FormItem>
                    )}
                />

                <FormField
                    control={form.control}
                    name="technical_issue"
                    render={({ field }) => (
                        <FormItem className="space-y-1">
                            <FormLabel>Technical Issue</FormLabel>
                            <FormControl>
                                <SearchableDropdown
                                    options={technicalIssue}
                                    selectedVal={event?.work_allocation?.technical_issue}
                                    handleChange={(val) =>
                                        updateEvent({
                                            work_allocation: {
                                                ...event.work_allocation,
                                                technical_issue: val,
                                            },
                                            update_obj: {
                                                name: event?.work_allocation?.name,
                                                data: {
                                                    technical_issue: val,
                                                },
                                            },
                                        })
                                    }
                                    placeholder="Select Technical Issue"
                                    label="technical_issue"
                                />
                            </FormControl>
                        </FormItem>
                    )}
                />

                <FormField
                    control={form.control}
                    name="audit_date"
                    className=""
                    render={({ field }) => (
                        <FormItem className="flex flex-col mt-2">
                            <FormLabel>Audit Date</FormLabel>
                            <Input value={event?.work_allocation?.audit_date} disabled />
                            {/* <Popover>
                                <PopoverTrigger asChild>
                                    <FormControl>
                                        <Button
                                            variant={'outline'}
                                            className={cn('pl-3 text-left font-normal', !field.value && 'text-muted-foreground')}
                                        >
                                            {field.value ? (
                                                format(field.value, Constant.DATE_FORMAT)
                                            ) : (
                                                <span className="text-gray-400">Pick a date</span>
                                            )}
                                            <CalendarIcon className="ml-auto h-4 w-4 opacity-50" />
                                        </Button>
                                    </FormControl>
                                </PopoverTrigger>
                                <PopoverContent className="w-auto p-0" align="start">
                                    <Calendar
                                        mode="single"
                                        selected={field.value}
                                        onSelect={field.onChange}
                                        disabled={(date) => date > new Date() || date < new Date('1900-01-01')}
                                        initialFocus
                                    />
                                </PopoverContent>
                            </Popover> */}
                        </FormItem>
                    )}
                />

                <FormField
                    control={form.control}
                    className=""
                    name="review_date"
                    render={({ field }) => (
                        <FormItem className="flex flex-col mt-2">
                            <FormLabel>Review Date</FormLabel>
                            <Input value={event?.work_allocation?.review_date} disabled />
                            {/* <Popover>
                                <PopoverTrigger asChild>
                                    <FormControl>
                                        <Button
                                            variant={'outline'}
                                            className={cn(' pl-3 text-left font-normal', !field.value && 'text-muted-foreground')}
                                        >
                                            {field.value ? (
                                                format(field.value, Constant.DATE_FORMAT)
                                            ) : (
                                                <span className="text-gray-400">Pick a date</span>
                                            )}
                                            <CalendarIcon className="ml-auto h-4 w-4 opacity-50" />
                                        </Button>
                                    </FormControl>
                                </PopoverTrigger>
                                <PopoverContent className="w-auto p-0" align="start">
                                    <Calendar
                                        mode="single"
                                        selected={field.value}
                                        onSelect={field.onChange}
                                        disabled={(date) => date > new Date() || date < new Date('1900-01-01')}
                                        initialFocus
                                    />
                                </PopoverContent>
                            </Popover> */}
                        </FormItem>
                    )}
                />
            </div>
            <hr className="mt-4 mb-4" />
            <h3 className="font-bold">Assign Users</h3>
            <div className="grid grid-cols-4 gap-y-3 gap-x-6 mt-5">
                <FormField
                    control={form.control}
                    name="coder"
                    render={({ field }) => (
                        <FormItem className="space-y-1">
                            <FormLabel>Coder Name</FormLabel>
                            <FormControl>
                                <Input value={event?.work_allocation?.coder_name} disabled />
                            </FormControl>
                        </FormItem>
                    )}
                />
                <FormField
                    control={form.control}
                    name="prod_tl"
                    render={({ field }) => (
                        <FormItem className="space-y-1">
                            <FormLabel>Prod TL</FormLabel>
                            <FormControl>
                                <Input value={event?.work_allocation?.production_tl_name} disabled />
                            </FormControl>
                        </FormItem>
                    )}
                />
                <FormField
                    control={form.control}
                    name="qa"
                    render={({ field }) => (
                        <FormItem className="space-y-1">
                            <FormLabel>QA </FormLabel>
                            <FormControl>
                                <Input value={event?.work_allocation?.qa_name} disabled />
                            </FormControl>
                        </FormItem>
                    )}
                />
                <FormField
                    control={form.control}
                    name="qa_tl"
                    render={({ field }) => (
                        <FormItem className="space-y-1">
                            <FormLabel>QA TL</FormLabel>
                            <FormControl>
                                <Input value={event?.work_allocation?.qa_tl_name} disabled />
                            </FormControl>
                        </FormItem>
                    )}
                />
                <FormField
                    control={form.control}
                    name="re_coder"
                    render={({ field }) => (
                        <FormItem className="space-y-1">
                            <FormLabel>Reassign Coder</FormLabel>
                            <FormControl>
                                <Input value={event?.work_allocation?.re_assigned_coder_name} disabled />
                            </FormControl>
                        </FormItem>
                    )}
                />
                <FormField
                    control={form.control}
                    name="re_prod_tl"
                    render={({ field }) => (
                        <FormItem className="space-y-1">
                            <FormLabel>Reassign Prod TL</FormLabel>
                            <FormControl>
                                <Input value={event?.work_allocation?.re_assigned_production_tl_name} disabled />
                            </FormControl>
                        </FormItem>
                    )}
                />
                <FormField
                    control={form.control}
                    name="re_qa"
                    render={({ field }) => (
                        <FormItem className="space-y-1">
                            <FormLabel>Reassign QA</FormLabel>
                            <FormControl>
                                <Input value={event?.work_allocation?.re_assigned_qa_name} disabled />
                            </FormControl>
                        </FormItem>
                    )}
                />
                <FormField
                    control={form.control}
                    name="re_qa_tl"
                    render={({ field }) => (
                        <FormItem className="space-y-1">
                            <FormLabel>Reassign QA TL</FormLabel>
                            <FormControl>
                                <Input value={event?.work_allocation?.re_assigned_qa_tl_name} disabled />
                            </FormControl>
                        </FormItem>
                    )}
                />

                <FormField
                    control={form.control}
                    name="chart_lock_user"
                    render={({ field }) => (
                        <FormItem className="space-y-1">
                            <FormLabel>Assign Chart Lock User</FormLabel>
                            <FormControl>
                                <Input value={event?.work_allocation?.chart_lock_user} disabled />
                            </FormControl>
                        </FormItem>
                    )}
                />

                <FormField
                    control={form.control}
                    name="chart_lock_date"
                    render={({ field }) => (
                        <FormItem className="flex flex-col mt-1">
                            <FormLabel required={true}>Chart Locked Date</FormLabel>
                            <Input disabled name="chart_lock_date" value={event?.work_allocation?.chart_lock_date} />
                        </FormItem>
                    )}
                />
            </div>

            <hr className="mt-4 mb-4" />
            <div className="grid grid-cols-2 gap-y-3 gap-x-6 mt-5">
                <FormField
                    control={form.control}
                    name="medical_coder_comments"
                    render={({ field }) => (
                        <FormItem className="flex flex-col mt-1">
                            <FormLabel required={true}>Coder Comment</FormLabel>
                            <Textarea
                                className="resize-none shadow-sm focus-visible:ring-transparent"
                                rows="2"
                                onChange={(e) =>
                                    updateEvent({
                                        work_allocation: {
                                            ...event.work_allocation,
                                            medical_coder_comments: e.target.value,
                                        },
                                        update_obj: {
                                            name: event?.work_allocation?.name,
                                            data: {
                                                medical_coder_comments: e.target.value,
                                            },
                                        },
                                    })
                                }
                                value={event?.work_allocation?.medical_coder_comments}
                            />
                        </FormItem>
                    )}
                />
                <FormField
                    control={form.control}
                    name="production_tl_comment"
                    render={({ field }) => (
                        <FormItem className="flex flex-col mt-1">
                            <FormLabel required={true}>Production TL Comment</FormLabel>
                            <Textarea
                                className="resize-none shadow-sm focus-visible:ring-transparent"
                                rows="2"
                                onChange={(e) =>
                                    updateEvent({
                                        work_allocation: {
                                            ...event.work_allocation,
                                            prod_tl_comments: e.target.value,
                                        },
                                        update_obj: {
                                            name: event?.work_allocation?.name,
                                            data: {
                                                prod_tl_comments: e.target.value,
                                            },
                                        },
                                    })
                                }
                                value={event?.work_allocation?.prod_tl_comments}
                            />
                        </FormItem>
                    )}
                />
                <FormField
                    control={form.control}
                    name="coder_comment_based_on_prod_tl_feedback"
                    render={({ field }) => (
                        <FormItem className="flex flex-col mt-1">
                            <FormLabel required={true}>Coder Comment Based On Production TL Feedback</FormLabel>
                            <Textarea
                                className="resize-none shadow-sm focus-visible:ring-transparent"
                                rows="2"
                                onChange={(e) =>
                                    updateEvent({
                                        work_allocation: {
                                            ...event.work_allocation,
                                            medical_coder_comments_: e.target.value,
                                        },
                                        update_obj: {
                                            name: event?.work_allocation?.name,
                                            data: {
                                                medical_coder_comments_: e.target.value,
                                            },
                                        },
                                    })
                                }
                                value={event?.work_allocation?.medical_coder_comments_}
                            />
                        </FormItem>
                    )}
                />
                <FormField
                    control={form.control}
                    name="operation_manager_comment_coder_error"
                    render={({ field }) => (
                        <FormItem className="flex flex-col mt-1">
                            <FormLabel required={true}>Operation Manager Comment</FormLabel>
                            <Textarea
                                className="resize-none shadow-sm focus-visible:ring-transparent"
                                rows="2"
                                onChange={(e) =>
                                    updateEvent({
                                        work_allocation: {
                                            ...event.work_allocation,
                                            op_comments: e.target.value,
                                        },
                                        update_obj: {
                                            name: event?.work_allocation?.name,
                                            data: {
                                                op_comments: e.target.value,
                                            },
                                        },
                                    })
                                }
                                value={event?.work_allocation?.op_comments}
                            />
                        </FormItem>
                    )}
                />
                <FormField
                    control={form.control}
                    name="qa_tl_comments"
                    render={({ field }) => (
                        <FormItem className="flex flex-col mt-1">
                            <FormLabel required={true}>QA TL Comments</FormLabel>
                            <Textarea
                                className="resize-none shadow-sm focus-visible:ring-transparent"
                                value={event?.work_allocation?.qa_tl_comments}
                                onChange={(e) =>
                                    updateEvent({
                                        work_allocation: {
                                            ...event.work_allocation,
                                            qa_tl_comments: e.target.value,
                                        },
                                        update_obj: {
                                            name: event?.work_allocation?.name,
                                            data: {
                                                qa_tl_comments: e.target.value,
                                            },
                                        },
                                    })
                                }
                                rows="2"
                            />
                        </FormItem>
                    )}
                />

                <FormField
                    control={form.control}
                    name="qa_comments_based_on_qa_tl"
                    render={({ field }) => (
                        <FormItem className="flex flex-col mt-1">
                            <FormLabel required={true}>QA Comments Based on QA TL Feedback</FormLabel>
                            <Textarea
                                className="resize-none shadow-sm focus-visible:ring-transparent"
                                rows="2"
                                onChange={(e) =>
                                    updateEvent({
                                        work_allocation: {
                                            ...event.work_allocation,
                                            qa_comments: e.target.value,
                                        },
                                        update_obj: {
                                            name: event?.work_allocation?.name,
                                            data: {
                                                qa_comments: e.target.value,
                                            },
                                        },
                                    })
                                }
                                value={event?.work_allocation?.qa_comments}
                            />
                        </FormItem>
                    )}
                />
                <FormField
                    control={form.control}
                    name="qa_manager_comment"
                    render={({ field }) => (
                        <FormItem className="flex flex-col mt-1">
                            <FormLabel required={true}>QA Manager Comments</FormLabel>
                            <Textarea
                                className="resize-none shadow-sm focus-visible:ring-transparent"
                                rows="2"
                                onChange={(e) =>
                                    updateEvent({
                                        work_allocation: {
                                            ...event.work_allocation,
                                            qam_comments: e.target.value,
                                        },
                                        update_obj: {
                                            name: event?.work_allocation?.name,
                                            data: {
                                                qam_comments: e.target.value,
                                            },
                                        },
                                    })
                                }
                                value={event?.work_allocation?.qam_comments}
                            />
                        </FormItem>
                    )}
                />

                <FormField
                    control={form.control}
                    name="qa_comments"
                    render={({ field }) => (
                        <FormItem className="flex flex-col mt-1">
                            <FormLabel required={true}>QA Comments</FormLabel>
                            <Textarea
                                className="resize-none shadow-sm focus-visible:ring-transparent"
                                rows="2"
                                onChange={(e) =>
                                    updateEvent({
                                        work_allocation: {
                                            ...event.work_allocation,
                                            qa_comments_: e.target.value,
                                        },
                                        update_obj: {
                                            name: event?.work_allocation?.name,
                                            data: {
                                                qa_comments_: e.target.value,
                                            },
                                        },
                                    })
                                }
                                value={event?.work_allocation?.qa_comments_}
                            />
                        </FormItem>
                    )}
                />
                <FormField
                    control={form.control}
                    name="prod_tl_based_on_qa_tl"
                    render={({ field }) => (
                        <FormItem className="flex flex-col mt-1">
                            <FormLabel required={true}>Prod TL Based on QA TL</FormLabel>
                            <Textarea
                                className="resize-none shadow-sm focus-visible:ring-transparent"
                                rows="2"
                                onChange={(e) =>
                                    updateEvent({
                                        work_allocation: {
                                            ...event.work_allocation,
                                            tl_comments: e.target.value,
                                        },
                                        update_obj: {
                                            name: event?.work_allocation?.name,
                                            data: {
                                                tl_comments: e.target.value,
                                            },
                                        },
                                    })
                                }
                                value={event?.work_allocation?.tl_comments}
                            />
                        </FormItem>
                    )}
                />
                <FormField
                    control={form.control}
                    name="coder_final_comment"
                    render={({ field }) => (
                        <FormItem className="flex flex-col mt-1">
                            <FormLabel required={true}>Coder Final Comment</FormLabel>
                            <Textarea
                                className="resize-none shadow-sm focus-visible:ring-transparent"
                                rows="2"
                                onChange={(e) =>
                                    updateEvent({
                                        work_allocation: {
                                            ...event.work_allocation,
                                            _medical_coder_comments: e.target.value,
                                        },
                                        update_obj: {
                                            name: event?.work_allocation?.name,
                                            data: {
                                                _medical_coder_comments: e.target.value,
                                            },
                                        },
                                    })
                                }
                                value={event?.work_allocation?._medical_coder_comments}
                            />
                        </FormItem>
                    )}
                />
                <FormField
                    control={form.control}
                    name="department_head_comment"
                    render={({ field }) => (
                        <FormItem className="flex flex-col mt-1">
                            <FormLabel required={true}>Department Head Comment</FormLabel>
                            <Textarea
                                className="resize-none shadow-sm focus-visible:ring-transparent"
                                rows="2"
                                onChange={(e) =>
                                    updateEvent({
                                        work_allocation: {
                                            ...event.work_allocation,
                                            dh_comments: e.target.value,
                                        },
                                        update_obj: {
                                            name: event?.work_allocation?.name,
                                            data: {
                                                dh_comments: e.target.value,
                                            },
                                        },
                                    })
                                }
                                value={event?.work_allocation?.dh_comments}
                            />
                        </FormItem>
                    )}
                />
            </div>
        </>
    )
}

export default Overview
